/**
 * Removes all keys from an object whose values are null or undefined.
 */
export function removeNullFromObject<T extends Record<string, any>>(obj: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => value !== null && value !== undefined),
  ) as Partial<T>;
}
